// extracted by mini-css-extract-plugin
export default {"root":"styles_root__7joeU","checkbox":"styles_checkbox__fXtQr","label":"styles_label__h3ZZc"};